import { httpClient } from "../http";

export interface ITestData {
  testId: number;
  testName: string;
  status: "done" | "in_progress" | "not_started";
  startedOn: string | null;
  finishedOn: string | null;
}

export interface IAssessmentTestsResponse {
  tests: ITestData[];
}

export class AssessmentTestsHttpService {
  static async getInviteTests(inviteId: number): Promise<IAssessmentTestsResponse> {
    const { data } = await httpClient.get(`/api/assessments/invites/${inviteId}/tests`);
    return data;
  }

  static async resetSelectedTests(inviteId: number, testIds: number[]): Promise<void> {
    await httpClient.patch(`/api/assessments/invites/${inviteId}/reset-tests`, {
      testIds,
    });
  }
}
